/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import { IconLinkTabItems } from "cms/components/icon-link-tabs/tab-items";
import { IconLinkTabNav } from "cms/components/icon-link-tabs/tab-nav";
import { cloneArray } from "cms/hooks/helpers/hooks-helpers";
import { useEffect, useState } from "react";

const IconLinkTabsComponent = (props) => {

    const component = props?.component;
    const initialTabs = component?.tabs;
    const title = component?.title;

    const [tabs, setTabs] = useState(initialTabs || []);
    const [initialized, setInitialized] = useState(false);

    const selectTab = (event, guid) => {
        event.preventDefault();
        const _tabs = cloneArray(tabs);
        _tabs.forEach((tab) => {
            tab.isVisible = tab.guid === guid;
        });

        if (_tabs.every((tab) => tab.isVisible === false)) {
            _tabs[0].isVisible = true;
        }
        setTabs(_tabs);
    };

    useEffect(() => {
        if (!initialized) {
            const _tabs = cloneArray(tabs);
            _tabs.forEach((tab, index) => {
                // true for the first tab, false otherwise
                tab.isVisible = index === 0;
            });
            setTabs(_tabs);
            setInitialized(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='icon-link-tabs-wrapper'>
            {title && <h2>{title}</h2>}
            <IconLinkTabNav
                tabs={tabs}
                selectTab={selectTab}
            />
            <IconLinkTabItems
                tabs={tabs}
            />
        </div>
    );
};

IconLinkTabsComponent.displayName = "IconLinkTabsComponent";
export { IconLinkTabsComponent }; 